export default __webpack_public_path__ + "logo-adigital-white.png?85792e43";